/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BroadcastScheduleDto } from '../../models/broadcast-schedule-dto';

export interface BroadcastScheduleControllerFindByEventIdV1$Params {
  eventId: string;
}

export function broadcastScheduleControllerFindByEventIdV1(http: HttpClient, rootUrl: string, params: BroadcastScheduleControllerFindByEventIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BroadcastScheduleDto>>> {
  const rb = new RequestBuilder(rootUrl, broadcastScheduleControllerFindByEventIdV1.PATH, 'get');
  if (params) {
    rb.path('eventId', params.eventId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BroadcastScheduleDto>>;
    })
  );
}

broadcastScheduleControllerFindByEventIdV1.PATH = '/api/v1/broadcast-schedule/event/{eventId}';
